
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency16AccountSettingsIntroduction from './digital-currency-16-account-settings-introduction.vue'

@Component({
  components: {
    DigitalCurrency16AccountSettingsIntroduction
  }
})
class DigitalCurrency15AccountSettingsButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean
  @Prop({ default: '' }) accountId?: string

  isVisibleAccountSettingsDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleAccountSettingsDialog = isVisible
  }
}

export default DigitalCurrency15AccountSettingsButton

